import EditIcon from "@mui/icons-material/EditOutlined";
import { useContext, useEffect, useState } from "react";
import { DetailList, DetailPanel } from "../../../shared/components/DetailList";
import { ActionButton } from "../../../shared/components/table/StyledTable";
import ConfigDataProvider, {
  ConfigDataContext,
} from "../../../shared/providers/ConfigDataProvider";
import { GET_CONFIG_DATA } from "../../../shared/reducer";
import OpeningHoursDialog from "./OpeningHoursDialog";

const OpeningHours = () => (
  <ConfigDataProvider>
    <OpeningHoursConsumer />
  </ConfigDataProvider>
);

const OpeningHoursConsumer = () => {
  const { state, dispatch } = useContext(ConfigDataContext);

  const frontendConfig = state?.data as any;

  useEffect(() => {
    dispatch({
      type: GET_CONFIG_DATA,
      id: "FrontendConfig",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Dialog state and handlers
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const start = frontendConfig?.OPENING_HOURS_START;
  const end = frontendConfig?.OPENING_HOURS_END;

  return (
    <>
      <DetailPanel
        title="Öffnungszeiten"
        action={
          <ActionButton
            icon={<EditIcon />}
            label="Öffnungszeiten bearbeiten"
            size="sm"
            onClick={() => setDialogOpen(true)}
          />
        }
      >
        <DetailList
          items={[
            {
              label: "Erreichbarkeit",
              value: start ? `${start}${end ? ` – ${end}` : ""}` : "—",
            },
          ]}
        />
      </DetailPanel>

      {dialogOpen && (
        <OpeningHoursDialog handleCloseDialog={() => setDialogOpen(false)} />
      )}
    </>
  );
};

export default OpeningHours;
